import { useState, useEffect, useMemo } from "react";
import "./tabs.css";
import TraineeOverview from "../../../../../TraineeOverviev/TraineeOverview";
import TrainingOverview from "../../../../../TrainingOverview/trainingOverview";
import ESGProgressDashboard from "../../../../../Progress/ESGProgressDashboard";
import CustomGraph from "../../CustomDashboard/CustomGraph";
import { useCurrentUser } from "../../../../../../hooks/useCurrentUser";
import TrainingDashboard from "../../../../../Training/training-dashboard/TrainingDashboard";
import ESGEnvironmentDashboard from "../../../../../Environment/environment";
import { Intensity } from "../intensity/Intensity";
import WaterDashboard from "../../../../../IotMeters/IotMeters/components/dashboard/WaterDashboard.jsx";
import DefaultMeterDashboard from "../../../../../IotMeters/IotMeters/dashboards/DefaultMeterDashboard.jsx";
import { DashboardView } from "../../../../../CarbonSequestration/CarbonSequestration.jsx";
import { useFinancialYears, useSources } from "../../../../../../hooks/useApiData.js";
import ESGDashboard from "../ESGDashboard/ESGDashboard.jsx";
import DeviationDashboard from "../deviationDashboard/DeviationDashboard.jsx";

const TabsComponent = ({
  graphSearchTerm,
  refreshKey,
  activebtnTab, 
  fromDate,
  keyTab,
  toDate,
  locationOption,
  timePeriods,
  financialYearId,
  graphData,
  frameworkValue,
  framework,
  todaysActivities,
  energyData,
  energyTriggerData,
  emissionTriggerData,
  permissionGraph,
  usersActivity,
  lastYearGraphData,
  compareLastTimePeriods,
  compareTCurrentimePeriods,
  financialYear,
  registerPublishHandler
}) => {
  const [activeSubTab, setActiveSubTab] = useState(0); 
  const { userType, companyId } = useCurrentUser();
  const [companyFramework, setCompanyFramework] = useState([]);
  const sources = useSources();
  const financialYears = useFinancialYears();

  // Convert sources to options format with sub-locations
  const sourceOptions = useMemo(() => 
    sources.map(s => ({
      value: s.id,
      label: s.unitCode || s.location?.area || 'Unknown',
      subLocations: (s.subLocation || []).map(sl => ({
        value: sl.id,
        label: sl.subLocation
      }))
    })), 
    [sources]
  );

  const financialYearOptions = useMemo(() => 
    financialYears.map(fy => ({
      value: fy.financial_year_value,
      label: fy.financial_year_value
    })), 
    [financialYears]
  );

  // Reset sub-tab (Dashboard/Custom/AI) whenever the main module changes
  useEffect(() => {
    setActiveSubTab(0);
  }, [activebtnTab]);

  useEffect(() => {
    if (Array.isArray(frameworkValue) && frameworkValue.length) {
      const frameworkId = frameworkValue.map((value) => value.id);
      setCompanyFramework(frameworkId);
    }
  }, [frameworkValue]);


  const SubTabRadio = ({ value, onChange }) => {
    const options = [
      { label: "Dashboard", value: 0 },
      { label: "Graphs", value: 1 },
      // { label: "AI Graph", value: 2 },
    ];

    return (
      <div style={{ display: "flex", gap: "16px", marginBottom: "16px" }}>
        {options.map(opt => (
          <label key={opt.value} style={{ cursor: "pointer" }}>
            <input
              type="radio"
              name="subTab"
              value={opt.value}
              checked={value === opt.value}
              onChange={() => onChange(opt.value)}
              style={{ marginRight: "6px" }}
            />
            {opt.label}
          </label>
        ))}
      </div>
    );
  };


  const renderUI = () => {
  
  const graphProps = {
    searchTerm: graphSearchTerm, 
    locationOption,
    timePeriods,
    financialYearId,
    refreshKey,
    fromDate,
    toDate
  };

  switch (activebtnTab) {
    case 0: 
      return (
        <ESGProgressDashboard 
          framework={framework} 
          timePeriods={timePeriods} 
          fromDate={fromDate} 
          toDate={toDate} 
          financialYearId={financialYearId} 
          locationOption={locationOption} 
          todaysActivities={todaysActivities} 
          usersActivity={usersActivity} 
        />
      );
    
    // CustomGraph instances with Search enabled
    case 1: return <ESGEnvironmentDashboard keyTab={keyTab} graphData={graphData} />
    case 2: return <CustomGraph tabName="Energy" {...graphProps}  registerPublishHandler={registerPublishHandler} />;
    case 3: return <CustomGraph tabName="Emission" {...graphProps}  registerPublishHandler={registerPublishHandler} />;
    case 4: return <CustomGraph tabName="Water" {...graphProps} registerPublishHandler={registerPublishHandler} />;
    case 5: return <CustomGraph tabName="Waste" {...graphProps} registerPublishHandler={registerPublishHandler} />;
    case 12: return <Intensity  framework={framework} timePeriods={timePeriods} fromDate={fromDate}  toDate={toDate}  financialYear={financialYear} locationOption={locationOption} />;
    case 6: 
      return (frameworkValue?.[0].id === 48 ? (
          <>
            <SubTabRadio value={activeSubTab} onChange={setActiveSubTab} />
            {activeSubTab === 0 ? 
              <ESGDashboard frameworkName={"HRSR-Diversity"} /> :
              <CustomGraph tabName="Diversity" {...graphProps} registerPublishHandler={registerPublishHandler}  />
            }
          </>
        ) : 
        <CustomGraph tabName="Diversity" {...graphProps} registerPublishHandler={registerPublishHandler}  />
      );
    case 7: 
      return (frameworkValue?.[0].id === 48 ? (
          <>
            <SubTabRadio value={activeSubTab} onChange={setActiveSubTab} />
            {activeSubTab === 0 ? 
              <ESGDashboard frameworkName={"HRSR-Employment"} /> :
              <CustomGraph tabName="Employment" {...graphProps}  registerPublishHandler={registerPublishHandler} />
            }
          </>
        ) : 
        <CustomGraph tabName="Employment" {...graphProps}  registerPublishHandler={registerPublishHandler} />
      );
    case 15: return <CustomGraph tabName="Occupancy" {...graphProps} registerPublishHandler={registerPublishHandler}  />;
    case 8: return <CustomGraph tabName="HealthSafety" {...graphProps} registerPublishHandler={registerPublishHandler}  />;
    case 9: return (
      <div>
        {companyFramework && companyFramework.includes(1) ? (activeSubTab === 0 ? (
          <>
            <SubTabRadio value={activeSubTab} onChange={setActiveSubTab} />
            <TrainingDashboard
              keyTab={keyTab}
              locationOption={locationOption}
              timePeriods={timePeriods}
              financialYearId={financialYearId}
              graphData={graphData}
              frameworkValue={frameworkValue}
              compareLastTimePeriods={compareLastTimePeriods}
              compareTCurrentimePeriods={compareTCurrentimePeriods}
              financialYear={financialYear}
            />
          </>
        ) : 
        <>
          <SubTabRadio value={activeSubTab} onChange={setActiveSubTab} />
          <CustomGraph tabName="Training" {...graphProps} registerPublishHandler={registerPublishHandler} />
        </>) : (
          <CustomGraph tabName="Training" {...graphProps} registerPublishHandler={registerPublishHandler} />
        )}    
      </div>
    );
    
    case 10: // Trainer Overview
      return (
        <div>
          <SubTabRadio value={activeSubTab} onChange={setActiveSubTab} />
          {activeSubTab === 0 ? (
          <TrainingOverview
            {...graphProps}
            graphData={graphData}
            frameworkValue={frameworkValue}
          />
        ): <CustomGraph tabName="TrainerOverview" {...graphProps} registerPublishHandler={registerPublishHandler}  />}
          
          
        </div>
      );
    
    case 11: // Trainee Overview
      return (
        <div>
          <SubTabRadio value={activeSubTab} onChange={setActiveSubTab} />
          {activeSubTab === 0 ? <TraineeOverview {...graphProps} />:<CustomGraph tabName="TraineeOverview" {...graphProps} registerPublishHandler={registerPublishHandler} />}
        </div>
      );
    
    case 16: 
      return <CustomGraph tabName="Governance" {...graphProps} registerPublishHandler={registerPublishHandler} />;

    case 17:
      return <ESGDashboard frameworkName={frameworkValue?.[0]?.display_name}/>;

    case 20:
      return <DeviationDashboard />;

    case 18:
      return String(companyId) === '362' ? 
        <WaterDashboard
          financialYearOptions={financialYearOptions}
          sourceOptions={sourceOptions}
        /> :

        <DefaultMeterDashboard
          financialYearOptions={financialYearOptions}
          sourceOptions={sourceOptions}
        />

    case 19:
      return <DashboardView />;
    
    default: 
      return (
        <div className="p-4 text-center">
          <h5>Select a module from the header to view data.</h5>
        </div>
      );
  }
};

  return (
    <div className="tabs-content-wrapper" style={{ overflowY: "auto", maxHeight: "calc(100vh - 200px)", padding: "10px" }}>
      {renderUI()}
    </div>
  );
};
export default TabsComponent;
